// import react hooks and props
import { ReactNode, useState, FC, MouseEvent } from 'react';

// import components
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import Menu from '@mui/material/Menu';

// import constants
import { DEFAULT_ACTION_ICON_SIZE } from './icon.consts';

interface Props {
  renderActions: (handleMenuClose: () => void) => ReactNode[];
}
export const MoreActionsMenu: FC<Props> = ({ renderActions }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleMenuClick}
        size="small"
        sx={{
          width: DEFAULT_ACTION_ICON_SIZE,
          height: DEFAULT_ACTION_ICON_SIZE
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {renderActions(handleMenuClose)}
      </Menu>
    </>
  );
};
